import { Model } from "@ofqual/portal-core/core/types";

export type SvrSubmission = {
  id: string;
  submissionType: number;
  subject: string;
  description: string;
  confidenceId: string;
  valenceId: string;
  intelligenceSourceId: string | null;
  active: boolean;
  submissionOrganisations: string[];
  submissionLinks: string[];
  submissionSources: string[];
  submissionRiskTypes: string[];
  createdDate: string;
  modifiedDate: string;
  createdByUpn: string;
  createdByDisplayName: string;
  modifiedByUpn: string;
  modifiedByDisplayName: string;
  resourceTags: number[];
};

export const fromApiModel = <T>(apiModel: Model) => {
  return {
    ...apiModel
  } as T;
};


export const toApiModel = <T extends { [key: string]: any }>(model: T) => {
  return {
    ...model,
  } as Model;
};

export const defaultValues: Partial<SvrSubmission> = {
  subject: "",
  description: "",
  submissionType: 0,
  intelligenceSourceId: "",
  valenceId: "",
  confidenceId: "",
  submissionOrganisations: [],
  submissionRiskTypes: [],
  submissionLinks: [],
  submissionSources: [],
  resourceTags: [],
};
